<script setup lang="ts">
    const { notifications, removeOne } = useNotifications();
</script>
<template>
    <div
        data-testid="notification-container"
        class="notifications"
    >
        <TransitionGroup>
            <LayoutNotification
                v-for="notification in notifications"
                :key="notification.id"
                :notification="notification"
                @click:close="removeOne(notification.id)"
            />
        </TransitionGroup>
    </div>
</template>

<style>
    @import '~/assets/scss/notifications/layout-notifications.scss';
</style>
